export const ALPHA_100: number = 0.04;
export const ALPHA_200: number = 0.08;
export const ALPHA_300: number = 0.12;
export const ALPHA_400: number = 0.16;
export const ALPHA_500: number = 0.24;
export const ALPHA_600: number = 0.36;
export const ALPHA_700: number = 0.56;
export const ALPHA_800: number = 0.8;
